import styles from "./Result.module.scss";
import ResultCardProps from "./ResultProps.interface";
import closeSearchOverlay from "../../../../thunks/closeSearchOverlay";

import React, { FunctionComponent } from "react";
import { useDispatch } from "react-redux";
import Anchor from "components/Anchor/Anchor";

const ResultCard: FunctionComponent<ResultCardProps> = (props) => {
    const dispatch = useDispatch();

    const onResultClick = () => {
        dispatch(closeSearchOverlay(props.wrapperElementRef));
    };

    return (
        <div onClick={onResultClick}>
            <Anchor className={styles.wrapper} to={props.content.url} >
                {props.content.name}
            </Anchor>
        </div>
    );
};

export default ResultCard;
